import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../features/user/userSlice";
import productReducer from "../features/products/productSlice";
import blogReducer from "../features/ads/adsSlice";
import cartReducer from "../redux/reducers/cartReducer";
import wishlistReducer from "../redux/reducers/wishlistReducer";

export const store = configureStore({
    reducer: {
        auth: authReducer,
        product: productReducer,
        blog: blogReducer,
        cart: cartReducer,
        wishlist: wishlistReducer,
    },
});